// src/select/src/select-group.tsx
import * as RadixSelectPrimitive from "@radix-ui/react-select";
import { jsx, jsxs } from "react/jsx-runtime";
var SelectGroup = ({ label, children }) => {
  return /* @__PURE__ */ jsxs(RadixSelectPrimitive.Group, { children: [
    /* @__PURE__ */ jsx(RadixSelectPrimitive.Label, { className: "mt-1 cursor-default select-none px-2 py-1 text-xs text-surface-body", children: label }),
    children
  ] });
};

export {
  SelectGroup
};
